export enum DATE_FILTER {
  EN_COURS = "En cours",
  CLOS = "Clos",
}

export enum LAST_MESSAGE_FILTER {
  DIX_MINUTES = "inférieur à 10 minutes",
  TRENTE_MINUTES = "inférieur à 30 minutes",
  UNE_HEURE = "inférieur à 1 heure",
  VINGT_QUATRE_HEURES = "inférieur à 24 heures",
}

export default DATE_FILTER;
